import { styled } from '@mui/material/styles';
import { Select } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

export const CommonSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: 4
    },
    '& .MuiSelect-icon': {
        color: '#fff',
        backgroundColor: '#0A579B',
        borderRadius: 4,
        padding: 4,
        height: '100%',
        width: 40,
        top: 0,
        right: 0
    }
}));

CommonSelect.defaultProps = {
    variant: 'outlined',
    IconComponent: KeyboardArrowDown
};
